import React from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function PRTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "Type", field: "purchasereturntype" },
    { label: "Category", field: "purchasereturncategory" },
    { label: "Purchase Return No.", field: "purchasereturnno" },
    { label: "Job Number", field: "jobnumber" },
    { label: "Purchase Return Date", field: "purchasereturndate" },
    { label: "Supplier Company Name", field: "suppliername" },
    { label: "Warehouse", field: "warehousename" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"PURCHASE RETURN"}
        apiField={"purchaseReturn"}
        addButton={"+ ADD"}
        createRoute={"/prCreate"}
        updateRoute={"/prView"}
        viewRoute={"/prView"}
      />
    </div>
  );
}

export default PRTable;
